import script from "./BarcodeScan.vue?vue&type=script&setup=true&lang=js"
export * from "./BarcodeScan.vue?vue&type=script&setup=true&lang=js"

import "./BarcodeScan.vue?vue&type=style&index=0&id=a10c15ee&lang=css"

const __exports__ = script;

export default __exports__